// extracted by mini-css-extract-plugin
module.exports = {"input":"Freshmail_input__1TJ07"};